import type { SearchFilters } from "./use-search-state";

interface RouteSearchValues {
  q?: string;
  genre?: string;
  style?: string;
  type?: string;
  format?: string;
  country?: string;
  origin?: string;
  page?: number;
  label?: string[];
  company?: string[];
}

function valueOrDefault<T>(value: T | undefined, fallback: T): T {
  return value === undefined ? fallback : value;
}

function optionalString(value: string | undefined): string | undefined {
  return value || undefined;
}

export function searchStateValues(
  search: RouteSearchValues,
  yearFrom: number | undefined,
  yearTo: number | undefined,
): SearchFilters {
  return {
    query: valueOrDefault(search.q, ""),
    genre: optionalString(search.genre),
    style: optionalString(search.style),
    type: optionalString(search.type) as SearchFilters["type"],
    format: optionalString(search.format) as SearchFilters["format"],
    country: optionalString(search.country),
    origin: optionalString(search.origin),
    yearFrom,
    yearTo,
    page: valueOrDefault(search.page, 1),
    label: valueOrDefault(search.label, []),
    company: valueOrDefault(search.company, []),
  };
}
